import { render } from "./NewDomainAdminDialog.vue?vue&type=template&id=52f3c265"
import script from "./NewDomainAdminDialog.vue?vue&type=script&lang=js"
export * from "./NewDomainAdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__